"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.H1 = void 0;
const Box_1 = require("./Box");
exports.H1 = Box_1.Box.withComponent('h1');

//# sourceMappingURL=H1.js.map
